"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckRubricInfo = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_i18next_1 = require("react-i18next");
var styled_components_1 = __importDefault(require("styled-components"));
var __1 = require("../../../..");
var StyledComponent = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 1rem;\n  border-radius: 4px;\n\n  svg {\n    display: none;\n  }\n"], ["\n  padding: 1rem;\n  border-radius: 4px;\n\n  svg {\n    display: none;\n  }\n"])));
var CheckRubricInfo = function (_a) {
    var rubric = _a.rubric, curriculum = _a.curriculum;
    var t = (0, react_i18next_1.useTranslation)('common').t;
    var renderCategoriesPanel = function () {
        if (!rubric)
            return null;
        var categories = rubric.categories, ratings = rubric.ratings;
        var allowedCategories = categories.filter(function (category) { return category.default; });
        // sort alphabetical
        var sortedCategories = allowedCategories.sort(function (a, b) { return a.name.localeCompare(b.name); });
        var borderStyle = categories[0].name === t('grading.customRubric.defaultCategoryName')
            ? 'border border-neutral20'
            : '';
        return sortedCategories.map(function (category) { return ((0, jsx_runtime_1.jsx)("div", { className: "mb-3 bg-white rounded-m ".concat(borderStyle), "data-testid": "rubric-category-panel", "data-category-name": category.name, children: (0, jsx_runtime_1.jsx)(__1.RubricsCategoryPanel, { curriculumId: curriculum, category: category, ratings: ratings, isReadOnly: true, enableExpand: false }) }, category.id)); });
    };
    return ((0, jsx_runtime_1.jsx)(StyledComponent, { "data-testid": "check-rubric-info", children: renderCategoriesPanel() }));
};
exports.CheckRubricInfo = CheckRubricInfo;
exports.default = exports.CheckRubricInfo;
var templateObject_1;
